export default __webpack_public_path__ + "locales/fi/DataReassignmentDialog.json?hash=b7cc91e343403684c1b42c291b5ad059";